import { withRouter } from '@shared/routerHistory';
import { Wizard as WizardComponent } from '@appsource/components/wizard';
import { createSetActiveStep, createSetItemInCartAction, createSetReceiptAction, createSetBillingTerm, createSetRecurringBilling, createSetSeatNumber, createSetTermId, createSetBillingAddressAction, createSetCheckoutId } from '@shared/actions/checkoutActions';
import { changeBillingRegion, createCustomer, generatePublisherOffer, getAppPricing, ensureAppDetailsData, getProduct, sendLeadInfo } from '@shared/actions/thunkActions';
import { CheckoutSource } from '@shared/Models';
import { connect } from 'react-redux';
import { checkoutBillingCountry } from '@shared/utils/checkoutUtils';
const mapStateToProps = (state, ownProps)=>{
    const { app, fetchedCustomers } = ownProps;
    const { checkout: { customers, activeCustomer, source, checkoutId }, config: { billingCountryCode } } = state;
    return {
        checkout: state.checkout,
        app,
        users: state.users,
        config: state.config,
        currentStep: state.checkout.currentStep,
        billingCountry: checkoutBillingCountry({
            customers,
            activeCustomer,
            defaultBillingCountry: billingCountryCode
        }),
        wizardLoading: !fetchedCustomers,
        featureFlags: state.config.featureFlags,
        productFetched: state.checkout.productFetched,
        source: source || CheckoutSource.Deeplink,
        checkoutId
    };
};
const mapDispatchToProps = (dispatch)=>{
    return {
        setActiveStep: (targetStepId)=>dispatch(createSetActiveStep(targetStepId)),
        createCustomer: ()=>dispatch(createCustomer()),
        setBillingCountry: (countryCode)=>dispatch(changeBillingRegion({
                countryCode: countryCode === null || countryCode === void 0 ? void 0 : countryCode.toLowerCase()
            })),
        fetchPricing: (entityId, isPrivate)=>isPrivate ? dispatch(ensureAppDetailsData(entityId, true)) : dispatch(getAppPricing(entityId)),
        setCartItem: (cartItem)=>dispatch(createSetItemInCartAction(cartItem)),
        setPurchaseReceipt: (receipt)=>dispatch(createSetReceiptAction(receipt)),
        setSoldToAddress: (soldToAddress)=>dispatch(createSetBillingAddressAction(soldToAddress)),
        generatePublisherToken: (subscriptionId)=>dispatch(generatePublisherOffer(subscriptionId)),
        setBillingTerm: (termDurationAction)=>dispatch(createSetBillingTerm(termDurationAction)),
        setRecurringBilling: (isRecurringAction)=>dispatch(createSetRecurringBilling(isRecurringAction)),
        setSeatNumber: (setSeatsProps)=>dispatch(createSetSeatNumber(setSeatsProps)),
        fetchProduct: (id, market)=>dispatch(getProduct(id, market)),
        createCheckoutId: ({ checkoutId })=>dispatch(createSetCheckoutId({
                checkoutId
            })),
        setSelectedTerm: (termIdAction)=>dispatch(createSetTermId(termIdAction)),
        sendLeadInfo: ({ item, ctaType, planId })=>{
            return dispatch(sendLeadInfo({
                item,
                ctaType,
                planId
            }));
        }
    };
};
const Wizard = connect(mapStateToProps, mapDispatchToProps)(WizardComponent);
export default withRouter(Wizard);
